import { memo } from 'react'

import { BottomSheet } from '~/shared/ui/BottomSheet'
import { Button } from '~/shared/ui/Button'
import { VStack } from '~/shared/ui/VStack'
import { Text } from '~/shared/ui/Text'

import type { ConfirmSheetProps } from './types'

/**
 * Шторка подтверждения поверх BottomSheet (спека 04 §6 «Разорвать нить», макет 16):
 * визуал → заголовок → текст → реплика Луни → кнопка действия (обычная/деструктивная) → ghost-отмена.
 */
export const ConfirmSheet = memo(function ConfirmSheet(props: ConfirmSheetProps) {
  const {
    isOpen,
    onClose,
    title,
    description,
    visual,
    note,
    confirmText,
    onConfirm,
    cancelText = 'Отмена',
    isDestructive = false,
    isLoading = false,
  } = props

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <BottomSheet.Header>
        <VStack gap='SMALL_M' align='CENTER'>
          {visual}
          {/* Спека 04 §6: заголовок 21/700 — точного токена нет, H1 (23/700) ближайший по весу. */}
          <Text variant='H1' as='h2' align='CENTER'>
            {title}
          </Text>
          {description && (
            <Text variant='BODY_S' color='SECONDARY' align='CENTER'>
              {description}
            </Text>
          )}
          {note}
        </VStack>
      </BottomSheet.Header>
      <BottomSheet.Footer>
        <VStack gap='SMALL_S'>
          <Button
            variant={isDestructive ? 'DESTRUCTIVE' : 'PRIMARY'}
            width='FULL'
            text={confirmText}
            isLoading={isLoading}
            onPress={onConfirm}
          />
          <Button variant='GHOST' width='FULL' text={cancelText} onPress={onClose} />
        </VStack>
      </BottomSheet.Footer>
    </BottomSheet>
  )
})
